import { useMemo } from 'react'
import withDefaultLayout from '@/hoc/WithDefaultLayout'
import { A4B_APPS } from '@/utils/constants'
import { useAppContext } from '@/components/AppContext'
import AdminBreadcrumb from '@/ui/organisms/AdminBreadcrumb'
import ManageTemple from '../components/ManageTemple'



const TempleProfileAdminUI = () => {
    const { app } = useAppContext()
    const isSrimandir = app === A4B_APPS.SRIMANDIR

    const getPageBreadcrumbs = useMemo(() => [
        { path: '/shrine/trustee-profile', breadcrumbName: 'Manage Trustee Profile' },
        { path: '/shrine/temple-profile', breadcrumbName: 'Manage Temple Profile' },
    ], [isSrimandir])

    return (
        <div style={{ padding: '0 40px' }}>
            <AdminBreadcrumb routes={getPageBreadcrumbs} />
            <ManageTemple />
        </div>
    )
}

export default withDefaultLayout(TempleProfileAdminUI)
